import { useTranslation } from 'react-i18next';
import { HiArrowUpRight } from 'react-icons/hi2';
import { ISearchBy } from '../interfaces/search';
import { utilService } from '../services/util.service';

interface IModuleProps {
  name: string;
  label: string;
  placeholder: string;
  activeModule: string | null;
  searchBy: ISearchBy;
  onChangeModule: (module: string | null) => void;
  handleFormSubmit: () => void;
}

export function SearchModule({
  activeModule,
  name,
  label,
  placeholder,
  searchBy,
  onChangeModule,
  handleFormSubmit,
}: IModuleProps) {
  const { t } = useTranslation();

  const getInputValue = (): string => {
    if (name === 'startDate') {
      if (searchBy.startDate && searchBy.endDate) {
        return utilService.formatDateMMMd(searchBy);
      }
      return '';
    }
    if (name === 'location') {
      if (searchBy.city && searchBy.state) {
        return `${searchBy.city}, ${searchBy.state}`;
      }
      return searchBy.state || searchBy.city || '';
    }
    return '';
  };

  const showSubmit = name === 'startDate';

  return (
    <div
      onClick={() => onChangeModule(name)}
      onKeyDown={(e) => e.key === 'Enter' && onChangeModule(name)}
      tabIndex={0}
      role="button"
      className={`module ${activeModule && name === activeModule ? 'active' : ''}`}
    >
      <div>
        <span className="module-title">{label}</span>
        <input
          type="text"
          name={name}
          readOnly
          className="module-selection"
          value={getInputValue()}
          placeholder={placeholder}
          onChange={() => {}}
        />
      </div>
      {showSubmit && (
        <button
          className="module-search-btn"
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            handleFormSubmit();
          }}
        >
          <span>{t('search-module-button-search')}</span>
          <HiArrowUpRight size={16} />
        </button>
      )}
    </div>
  );
}
